import React, { FC, ReactNode } from 'react';
import { observer } from 'mobx-react';
import Link from 'next/link';
import { ISidebarElement, SidebarElement } from './SidebarElement';
export const SidebarListElement: FC<{
  collapsed: boolean;
  onClick: (element) => void;
  element: ISidebarElement;
  active: boolean;
  children?: ReactNode;
}> = observer(({
  collapsed,
  onClick,
  element,
  active,
  children
}) => <li key={element.id} className="group flex h-24 w-full cursor-pointer">
    <Link href={element.url} onClick={e => onClick(element)} className={`
        hover:text-secondary-300
        relative flex w-full grow fill-current
        ${active ? 'text-secondary-300 bg-white' : 'text-grey'}
      `}>
      <div className={active ? `
              border-primary-300 bg-primary-300 relative top-0 left-0 h-full w-2 rounded-r-full
              border border-t-0 border-r-2 border-b-0 border-l-0
              md:border-r-4
            ` : ''} />
      <SidebarElement element={element} collapsed={collapsed} active={active} />
      {children}
    </Link>
  </li>);